import { render, staticRenderFns } from "./ListagemItens.vue?vue&type=template&id=27937d6d"
import script from "./ListagemItens.vue?vue&type=script&lang=js"
export * from "./ListagemItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports